import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './configureStore';
import App from './app/App';
import { configureAmplify } from './app/configureAmplify';
import { SessionProvider } from './context/SessionProvider';
import { ThemeProvider } from './context/ThemeProvider';
import { APP_BASENAME } from './lib/appUrl';
import './tailwind.css';

configureAmplify();

// Move any path outside /app under it so BrowserRouter's basename matches; outside the basename the router
// renders nothing. Keep the path, query and hash: invitation emails link to <domain>?invid=<id>, guest reminder
// emails and links shared before the basename fix use <domain>/guest/<hash> and <domain>/in/link/<id>.
const { pathname, search, hash } = window.location;
if (pathname !== APP_BASENAME && !pathname.startsWith(`${APP_BASENAME}/`)) {
  window.location.replace(`${APP_BASENAME}${pathname === '/' ? '' : pathname}${search}${hash}`);
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <BrowserRouter basename={APP_BASENAME}>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
);
